/* eslint-disable */ import React from "react";
export default function PreviousDownloadsTable(props) {
    var _props_description, _section_description, _section_items, _props_downloadsFooter;
    return /*#__PURE__*/ React.createElement("div", {
        className: "page-container first:mt-0 mt-8 md:mt-0"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "prose max-w-full"
    }, /*#__PURE__*/ React.createElement("h2", null, props === null || props === void 0 ? void 0 : props.header), /*#__PURE__*/ React.createElement("p", {
        className: "post-headline"
    }, "Release Date: ", props === null || props === void 0 ? void 0 : props.releaseDate), /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: (_props_description = props === null || props === void 0 ? void 0 : props.description) !== null && _props_description !== void 0 ? _props_description : ""
        }
    })), /*#__PURE__*/ React.createElement("h2", null, props === null || props === void 0 ? void 0 : props.subHeader), /*#__PURE__*/ React.createElement("table", {
        className: "table knime-table w-full"
    }, /*#__PURE__*/ React.createElement("tbody", null, (props === null || props === void 0 ? void 0 : props.downloadSections) && (props === null || props === void 0 ? void 0 : props.downloadSections.map(function(section, index) {
        /*#__PURE__*/ return React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("tr", {
            className: "theme-header",
            key: index
        }, /*#__PURE__*/ React.createElement("td", {
            colSpan: 2
        }, /*#__PURE__*/ React.createElement("strong", {
            className: "font-bold"
        }, section === null || section === void 0 ? void 0 : section.sectionHeader), /*#__PURE__*/ React.createElement("em", null, /*#__PURE__*/ React.createElement("div", {
            dangerouslySetInnerHTML: {
                __html: (_section_description = section === null || section === void 0 ? void 0 : section.description) !== null && _section_description !== void 0 ? _section_description : ""
            }
        })))), /*#__PURE__*/ React.createElement(Section, {
            // @ts-ignore
            items: (_section_items = section === null || section === void 0 ? void 0 : section.items) !== null && _section_items !== void 0 ? _section_items : []
        }));
    })))), /*#__PURE__*/ React.createElement("footer", {
        className: "mt-12"
    }, /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: (_props_downloadsFooter = props === null || props === void 0 ? void 0 : props.downloadsFooter) !== null && _props_downloadsFooter !== void 0 ? _props_downloadsFooter : ""
        }
    })))));
}
function Section(param) {
    var items = param.items;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, items && items.map(function(item, itemIndex) {
        /*#__PURE__*/ return React.createElement("tr", {
            key: itemIndex
        }, /*#__PURE__*/ React.createElement("td", null, item === null || item === void 0 ? void 0 : item.title), /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement("a", {
            href: "".concat(item === null || item === void 0 ? void 0 : item.downloadUriFromMedia)
        }, item === null || item === void 0 ? void 0 : item.downloadLabel)));
    }));
}
